function FooterBottom(props) {
    return (
        <div className="footer-bottom">
            <div className="container">
                <div className="row">
                    <p className="pull-left">Copyright © 2013 E-SHOPPER Inc. All rights reserved.</p>
                    <p className="pull-right">Designed by <span><a href="http://www.themeum.com">Themeum</a></span></p>
                </div>
            </div>
        </div>
    );
}

export default FooterBottom;